import { Component, OnInit } from '@angular/core';
import { TermsOfServicePageService } from './terms-of-service-page.service';

@Component({
    selector: 'app-terms-of-service-page',
    templateUrl: './terms-of-service-page.component.html',
    styleUrls: ['./terms-of-service-page.component.scss']
})
export class TermsOfServicePageComponent implements OnInit {

	public data: any;

    constructor(
		private content: TermsOfServicePageService
    ) {
    }

    ngOnInit(): void {}

}